import React, { ComponentType, FC } from "react";
import { Redirect } from "react-router-dom";

const RequiresAuth = < P extends any > ( Component: ComponentType< P > ): FC< P > => ( props ) => {

    const isAuthenticated = localStorage.getItem( 'shreeDevToken' ) as string;
    // const isAuthenticated = true;

    if ( isAuthenticated ) {

        console.log( 'You are authenticated' );
        return < Component { ...props } />;

    }
    else{
    console.log( 'You are not authenticated' );

    return (
        
        <Redirect to = { { pathname: '/login', } } />
    );
    }
};

export default RequiresAuth;
